<template>
    <div class="section" v-show="showPermits">
        <h2 class="sectionTitle">Latest Permits to Drill</h2>
        <div class="sectionContent cardPlacement">
           <div class="logCard" v-for="(p, index) in permits" :key="index">
               <div>
                   <div v-for="obj in formatGeneral(p)" :key="obj.field" class="dataItem">
                        <p v-if="obj.field === 'Operator'">{{obj.field}}: <router-link :to="{name: 'Operators', params: {operator: p.operShort}}" class="link dataEmphasis">{{obj.val}}</router-link></p>
                        <p v-else-if="obj.field === 'Lease Number'">{{obj.field}}: <router-link :to="{name: 'Leases', params: {lease: p.leaseNum}}" class="link dataEmphasis">{{obj.val}}</router-link></p>
                        <p v-else-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
               </div>
               <div>
                    <div v-for="obj in formatDetails(p)" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
               </div>
           </div>
        </div>
    </div>
</template>

<script>
import { formatDateLT, readFromObj } from '../../helpers/Formatting.js';

export default {
    name: 'trending-latest-well-plans',
    data: () => ({
        showPermits: false,
        permits: [],
    }),
    methods: {
        updateInfo: function(permits) {
            var globv = this;
            globv.permits = permits;
            globv.showPermits = globv.permits.length > 0;
        },
        formatGeneral: function(p) {
            let expectedVariables = [
                {
                    varName: "well.id",
                    fieldName: "Well ID"
                },
                {
                    varName: "well.name",
                    fieldName: "Well Name"
                },
                {
                    varName: "well.type",
                    fieldName: "Well Type"
                },
                {
                    varName: "operator",
                    fieldName: "Operator"
                },
                {
                    varName: "leaseNum",
                    fieldName: "Lease Number"
                },
                {
                    varName: "surfaceBlock",
                    fieldName: "Surface Block"
                },
                {
                    varName: "bottomBlock",
                    fieldName: "Bottom Block"
                },
            ]

            return readFromObj(p, expectedVariables);
        },
        formatDetails: function(p) {
            let expectedVariables = [
                {
                    varName: "workBeginDate",
                    fieldName: "Begin Date",
                    format: formatDateLT
                },
                {
                    varName: "status",
                    fieldName: "Status"
                },
                {
                    varName: "statusDate",
                    fieldName: "Status Date",
                    format: formatDateLT
                },
                {
                    varName: "coordinates",
                    fieldName: "Latitude / Longitude",
                    format: function(coord) {
                        if (coord && coord.length === 2) {
                            let lat = coord[1];
                            let lon = coord[0];
                            if (lat !== null && lon !== null) {
                                return lat + "° / " + lon + "°";
                            }
                        }

                        return null;
                    }
                },
                {
                    varName: "protraction",
                    fieldName: "Protraction"
                },
                {
                    varName: "description",
                    fieldName: "Description"
                }
            ]

            return readFromObj(p, expectedVariables);
        }
    }
}
</script>